import React from 'react';
import { Grid2, TextField } from '@mui/material';

function GA4Form({ values, setFieldValue }) {
    return (
        <>
            <Grid2 size={{ xs: 12 }}>
                <TextField
                    fullWidth
                    label="Google Analytics 4 Measurement ID"
                    value={values.settings?.trackingId || ''}
                    onChange={(ev) =>
                        setFieldValue('settings', {
                            ...values.settings,
                            trackingId: ev.target.value,
                        })
                    }
                    placeholder="G-XXXXXXXXXX"
                    helperText="Enter your GA4 Measurement ID (starts with G-)"
                />
            </Grid2>
        </>
    );
}

export default GA4Form;
